import { DateTime } from "luxon";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface TimezoneOption {
  value: string;
  label: string;
}

export function useTimezones(): TimezoneOption[] {
  const { t, i18n } = useTranslation();

  const timezones = useMemo<TimezoneOption[]>(() => {
    const zones = [
      { value: "Etc/UTC", label: t("cities.utc") },
      { value: "Etc/GMT", label: t("cities.gmt") },

      { value: "America/Sao_Paulo", label: t("cities.saoPaulo") },
      { value: "America/Recife", label: t("cities.recife") },
      { value: "America/Bahia", label: t("cities.bahia") },
      {
        value: "America/Argentina/Buenos_Aires",
        label: t("cities.buenosAires"),
      },
      { value: "America/Santiago", label: t("cities.santiago") },
      { value: "America/Bogota", label: t("cities.bogota") },
      { value: "America/Lima", label: t("cities.lima") },
      { value: "America/Mexico_City", label: t("cities.mexicoCity") },

      { value: "America/New_York", label: t("cities.newYork") },
      { value: "America/Chicago", label: t("cities.chicago") },
      { value: "America/Denver", label: t("cities.denver") },
      { value: "America/Los_Angeles", label: t("cities.losAngeles") },
      { value: "America/Toronto", label: t("cities.toronto") },
      { value: "America/Vancouver", label: t("cities.vancouver") },

      { value: "Europe/London", label: t("cities.london") },
      { value: "Europe/Lisbon", label: t("cities.lisbon") },
      { value: "Europe/Paris", label: t("cities.paris") },
      { value: "Europe/Berlin", label: t("cities.berlin") },
      { value: "Europe/Madrid", label: t("cities.madrid") },
      { value: "Europe/Rome", label: t("cities.rome") },
      { value: "Europe/Stockholm", label: t("cities.stockholm") },
      { value: "Europe/Copenhagen", label: t("cities.copenhagen") },
      { value: "Europe/Amsterdam", label: t("cities.amsterdam") },
      { value: "Europe/Athens", label: t("cities.athens") },

      { value: "Asia/Tokyo", label: t("cities.tokyo") },
      { value: "Asia/Shanghai", label: t("cities.shanghai") },
      { value: "Asia/Seoul", label: t("cities.seoul") },
      { value: "Asia/Bangkok", label: t("cities.bangkok") },
      { value: "Asia/Kolkata", label: t("cities.mumbai") },
      { value: "Asia/Dubai", label: t("cities.dubai") },

      { value: "Australia/Sydney", label: t("cities.sydney") },
      { value: "Pacific/Auckland", label: t("cities.auckland") },
    ];

    const now = DateTime.now();

    return zones.map((zone) => {
      const offset = now.setZone(zone.value).toFormat("ZZ");
      const iana = now
        .setZone(zone.value)
        .setLocale(i18n.language)
        .toFormat("ZZZZZ");
      const gmt = `UTC${offset}`;
      return {
        value: zone.value,
        label: `${zone.label} - (${gmt}) - ${iana}`,
      };
    });
  }, [i18n.language]);

  return timezones;
}
